export default "__VITE_ASSET__COtfcXer__"